package org.multipaz.wallet.shared

class WalletBackendNotSignedInException(message: String? = null): WalletBackendException(message)